var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"navbar",attrs:{"default-active":_vm.activeTab,"mode":"horizontal","text-color":_vm.textColor,"active-text-color":_vm.activeTextColor},on:{"select":_vm.handleTabChange}},_vm._l((_vm.navTabs),function(tab){return _c('el-menu-item',{key:tab.value,attrs:{"index":tab.value}},[_vm._v(" "+_vm._s(_vm.$t(tab.label))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }